<template>
    <div>
        <template v-if="corp_status == true">
            <template>
                <div class="global-main bank-account-linking">
                    <div class="bank-account-linking-inner">
                        <div class="align-center">
                                <img class="mb-3" src="/images/meezan-logo.jpg" width="250" alt="" /> <br>
                        </div>
                        <h2 class="mb-4"> Account De-Linking </h2>
                        <form @submit.prevent="accountDeLinking()">
                            <div class="form-group">
                                <label class="label block-label"> Account Number </label>
                                <input type="text" class="form-control" name="AccountNo" readonly @keypress="isNumber($event)" maxlength="14" v-model="form.AccountNo" :class="{ 'is-invalid': form.errors.has('AccountNo') }" autocomplete="off"/>
                                <has-error :form="form" field="AccountNo"></has-error>
                            </div>
                            <div class="form-group">
                                <label class="label block-label"> NTN Number </label>
                                <input type="text" class="form-control" readonly placeholder="Enter NTN Number"  maxlength="13" name="NTN" v-model="form.NTN" :class="{ 'is-invalid': form.errors.has('NTN') }" autocomplete="off"/>
                                <has-error :form="form" field="NTN"></has-error>
                            </div>
                            <div class="form-group mb-0 text-right">
                                <button :disabled="form.busy" class="btn btn-primary proceed active"> Proceed </button>
                            </div>
                        </form>
                    </div>
                </div>
            </template>
        </template>
        <template v-else-if="corp_status === null">
            <preLoader></preLoader>
        </template>
        <template v-else>
            <notAllowed></notAllowed>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {

                form: new Form({
                    AccountNo: '',
                    NTN : '',
                }),
                corp_status: null,
                account_management: null
            };
        },
        methods: {
            accountDeLinking(){
                this.$Progress.start();
                this.form.post("/api/accountDeLinking")
                .then(res => {
                    if(res.status == 200){
                        if(res.data.status == 200){
                            this.$Progress.finish();
                            this.showToastBox('success','Account de-link successfully');
                            window.location.href = "/";
                        }else{
                            this.$Progress.fail();
                            this.showAlertBox('error','System is not responding! Please try again later.');
                        }
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error','System is not responding! Please try again later.');
                    }
                })
                .catch(err => {
                    console.log(err);
                    this.$Progress.fail();
                    this.showAlertBox('error','Some error in your form data');
                });
            },

            getCompanyAccountNo(){
                this.$Progress.start();
                axios.get('/api/getCompanyAccountNo')
                .then(res => {
                    if(res.status == 200){
                        this.form.AccountNo = this.makeMask(res.data.company.walletID);
                        this.$Progress.finish();
                    }else{
                        this.$Progress.fail();
                    }
                })
                .catch(err => {
                    console.log(err);
                    this.$Progress.fail();
                    this.showAlertBox('error','System is not responding! Please try again later.');
                });
            },
            getCompanyNTN(){
                this.$Progress.start();
                axios.get('/api/getCompanyNTN')
                .then(res => {
                    if(res.status == 200){
                        this.form.NTN = res.data.company.ntn;
                        if(res.data.company.corp_account_status == "LINKED" || res.data.company.corp_account_status == "PINCREATED" || res.data.company.corp_account_status == "RELINK" ){
                            this.corp_status = true;
                        }else{
                           this.corp_status = false;
                        }
                        this.$Progress.finish();
                    }else{
                        this.$Progress.fail();
                    }
                })
                .catch(err => {
                    console.log(err);
                    this.$Progress.fail();
                    this.showAlertBox('error','System is not responding! Please try again later.');
                });
            }
        },
        mounted() {
            this.getCompanyAccountNo();
            this.getCompanyNTN();
        },
    }
</script>
